exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.auth-dialog .dialog-content[data-v-26814c57] {\n  padding: 0 0.6rem;\n  padding-bottom: 0.533333rem;\n  position: relative;\n}\n.auth-dialog .title[data-v-26814c57] {\n  font-size: 0.56rem;\n  height: 0.96rem;\n  line-height: 0.96rem;\n  font-family: PingFangSC-Semibold, PingFang SC;\n  font-weight: 600;\n}\n.auth-dialog .tip[data-v-26814c57] {\n  font-size: 0.373333rem;\n  line-height: 0.533333rem;\n  margin-top: 0.493333rem;\n  font-family: PingFangSC-Regular, PingFang SC;\n  font-weight: 400;\n  color: #999;\n}\n.auth-dialog .confirm-btn[data-v-26814c57] {\n  margin: 0.533333rem auto 0;\n  display: block;\n}", ""]);

// exports
